// extracted by css-extract-rspack-plugin
export default {"textAreaWrapper":"text-area-wrapper--P5WfynKBvN4SpqFj"};